export const ASYNC_BUYFLOW_ROUTES = ['/tvi/buy/'];
export const NON_ASYNC_ROUTES = ['/tvi/reservation', '/tvi/instant-on'];

export const isAsyncRoute = (pathname: string) =>
  ASYNC_BUYFLOW_ROUTES.some((route) =>
    pathname.startsWith(route.replace(/\/$/, ''))
  );

export const isNonAsyncRoute = (pathname: string) =>
  NON_ASYNC_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + '/')
  );
